import React, {Component} from 'react'
import PropType from 'prop-types'
import AccountStatistics from "./AccountStatistics"

class ChooseDevices extends Component {
    state = {
        current: ''
    }

    _handleChangeDevice = e => {
        const {value} = e.target

        this.setState({
            current: value
        })

        this.props.onChange(value)
    }

    render() {
        return (
            <div className="ChooseDevices col-md-4 col-12">
                <label>Choose devices</label>

                <div className="form-group">
                    <select
                        className="form-control"
                        onChange={this._handleChangeDevice} value={this.state.current}>
                        <option value="">Computer 1 - 771 546 545</option>
                        {/*<option value="d2">Computer 2 - 1 055 917 537</option>*/}
                        <option value="d3">Computer 3 - 344 648 255</option>
                        <option value="d4">Computer 4</option>
                    </select>
                </div>

                <AccountStatistics/>
            </div>
        )
    }
}

ChooseDevices.propTypes = {
    onChange: PropType.func.isRequired,
}

export default ChooseDevices



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/accounts/ChooseDevices.js